module.exports = __webpack_public_path__ + "static/media/table.f3a339e3.svg";